import { ProductPlaceholder } from '../enums/placeholder';
import { DiscountHtmlId, HtmlId, SummaryCardHtmlId } from '../enums/elementId';
import { ITooltipProperties, Tooltip, createTooltip } from '@vfde-brix/ws10/tooltip';
import { getCMSConfig } from '../util/cms';
import { getTooltipProps } from '../util/components/tooltipHelper';
import { createComponentById, NO_PATTERN_BUSINESS_LOGIC } from '@vfde-brix/ws10/core';
import { addTooltipTracking } from '../util/tracking';
import { replaceAllPlaceholders } from '../util/formatter';

const FEE_TOOLTIP_ID = 'installation-fee-tooltip';

export const mountToolTip = (wrapperId: HtmlId, props?: ITooltipProperties) => {
    const tooltip: Tooltip | null = createComponentById(
        createTooltip,
        wrapperId,
        props || NO_PATTERN_BUSINESS_LOGIC
    );

    tooltip && addTooltipTracking(tooltip.getContainerElement());

    return tooltip;
};

export const mountPriceSublineTooltip = (wrapperId: HtmlId) =>
    mountToolTip(wrapperId, getTooltipProps(wrapperId, getCMSConfig()?.tariffDetails?.tooltip));

export const mountFormSublineTooltip = (wrapperId: HtmlId) =>
    mountToolTip(wrapperId, getTooltipProps(wrapperId, getCMSConfig()?.avcTooltip));

export const mountLegalTextTooltip = (wrapperId: HtmlId, installationFee?: number) => {
    const tooltip = getCMSConfig().offerSummaryCard.additionalPrice.installationFeeTooltip;

    if (!installationFee) {
        return;
    }

    mountToolTip(wrapperId, getTooltipProps(wrapperId, {
        text: replaceAllPlaceholders(tooltip.text, {
            [ProductPlaceholder.INSTALLATION_FEE]: installationFee.toString(),
        }),
        id: FEE_TOOLTIP_ID,
    }));
};

export const mountGigakombiDiscountCardTooltip = () =>
    mountToolTip(
        DiscountHtmlId.GIGAKOMBI_DISCOUNT_CARD_TOOLTIP,
        getTooltipProps(DiscountHtmlId.GIGAKOMBI_DISCOUNT_CARD_TOOLTIP, getCMSConfig()?.gigakombiTooltip),
    );

export const updateSummaryCardBadgeTooltip = (isFnF: boolean, isGigakombi: boolean) => {
    const tooltipConfig = isFnF
        ? getCMSConfig()?.ffTooltip
        : isGigakombi
            ? getCMSConfig().gigakombiTooltip
            : undefined;

    mountToolTip(
        SummaryCardHtmlId.HIGHLIGHT_BADGE_TOOLTIP,
        getTooltipProps(SummaryCardHtmlId.HIGHLIGHT_BADGE_TOOLTIP, tooltipConfig),
    );
};
